import React from 'react';
import PropTypes from 'prop-types';

import { BET_BUILDER } from '@tickets/constants';

const BetType = ({ data }) => {
  const typeName = data?.dataFromSwarm?.type_name;

  return (
    <div className="ticket-type">
      { typeName === BET_BUILDER && <i className="global-icon icon-bet-builder ticket-betbuilder" /> }
      <p>{typeName ?? '-'}</p>
    </div>
  );
};

export default BetType;

BetType.propTypes = {
  data: PropTypes.object,
};
